import { CustomSerializer } from './custom-serializer';
import { Data, FieldValueTransformer } from './types';
import { getDef, isSchema, isSchemaInstance, isSerializer } from './utils';

export function serialize<U extends Data, T extends Data = Data>(record: T): U;
export function serialize<U extends Data, T extends Data = Data>(record: T[]): U[];
export function serialize<T extends Data>(record: T) {
	if (Array.isArray(record)) {
		return record.map((r) => serialize(r)) as T[];
	}

	if (!isSchema(record.constructor)) {
		throw new Error(`${record.constructor.name} is not a schema`);
	}

	const def = getDef(record.constructor);
	const data: any = {};

	for (const attr of def.attrs()) {
		const from = attr.from;
		const field = attr.field;

		if (!from) {
			continue;
		}

		const resolvedValue = record[attr.name];

		if (Array.isArray(resolvedValue) !== Array.isArray(field.transformer) && !(field.transformer.prototype instanceof CustomSerializer)) {
			throw new Error(`Data and transformer must be the same type, field: ${field.transformer}, data: ${resolvedValue}`);
		}

		data[from.name] = convertData(resolvedValue, field.transformer);
	}

	return data;
}

function convertData(data: any, fnArrayOrTsfmr: FieldValueTransformer): any {
	if (Array.isArray(data) && Array.isArray(fnArrayOrTsfmr)) {
		const [fnOrTsfmr] = fnArrayOrTsfmr;
		return data.map((d) => convertData(d, fnOrTsfmr));
	}

	if (data === null) {
		return null;
	}

	if (!fnArrayOrTsfmr) {
		return data;
	}

	if (isSchemaInstance(data)) {
		return serialize(data);
	}

	if (isSerializer(fnArrayOrTsfmr)) {
		return new fnArrayOrTsfmr().serialize(data);
	}

	return fnArrayOrTsfmr(data);
}
